const DEVICE_ID_STORAGE_KEY = 'deviceId'

let deviceIdPromise = null

function readStoredDeviceId () {
  try {
    return localStorage.getItem(DEVICE_ID_STORAGE_KEY) || ''
  } catch {
    return ''
  }
}

function writeStoredDeviceId (deviceId) {
  try {
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId)
  } catch {
    // ignore quota / privacy mode
  }
}

function normalizeUrlDeviceId (raw) {
  const value = String(raw || '').trim()
  if (!value || value.length > 128) return ''
  return /^[A-Za-z0-9_-]+$/.test(value) ? value : ''
}

function getUrlDeviceId () {
  if (typeof window === 'undefined') return ''
  try {
    return normalizeUrlDeviceId(new URLSearchParams(window.location.search).get(DEVICE_ID_STORAGE_KEY))
  } catch {
    return ''
  }
}

function randomHex (length) {
  const bytes = new Uint8Array(Math.ceil(length / 2))
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('').slice(0, length)
}

function createDeviceId () {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '')
  }
  return randomHex(32)
}

/** URL 优先，其次 localStorage，最后首次生成并缓存。 */
export function resolveDeviceId () {
  const urlDeviceId = getUrlDeviceId()
  if (urlDeviceId) {
    writeStoredDeviceId(urlDeviceId)
    return urlDeviceId
  }

  const storedDeviceId = readStoredDeviceId()
  if (storedDeviceId) return storedDeviceId

  const deviceId = createDeviceId()
  writeStoredDeviceId(deviceId)
  logger.debug('设备 ID 已生成:', deviceId)
  return deviceId
}

/** 保证 deviceId 已写入 localStorage，并发调用共享同一 Promise */
export function ensureDeviceId () {
  if (!deviceIdPromise) {
    deviceIdPromise = Promise.resolve()
      .then(resolveDeviceId)
      .catch((error) => {
        deviceIdPromise = null
        throw error
      })
  }

  return deviceIdPromise
}

/** @deprecated 使用 ensureDeviceId，保留别名供现有调用 */
export async function getDeviceId () {
  return ensureDeviceId()
}

/**
 * 判断当前设备是否为 Apple 设备 (iPhone, iPad, iPod 或 Mac)
 * @returns {boolean}
 */
export const isAppleDevice = () => {
  if (typeof window === 'undefined') return false

  const ua = window.navigator.userAgent.toLowerCase()
  // 1. 基础正则判断：iPhone, iPod, iPad (旧版)
  const isIOS = /iphone|ipad|ipod/.test(ua)
  // 2. Mac 电脑识别
  const isMac = /macintosh|mac os x/.test(ua)

  // 3. 针对新版 iPadOS 的特殊识别
  // 现代 iPad 默认请求桌面网站，UA 看起来像 Mac，但支持多点触控
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1

  return isIOS || isMac || isIPadOS
}
